module.exports = new __parcel__URL__("OKR Tracking.a04718bb.svg").toString();